import './solutions.component.scss'

import Swiper, { Navigation } from 'swiper'
import GLightbox from 'glightbox'

import 'swiper/css'
import 'swiper/css/navigation'
import 'glightbox/dist/css/glightbox.min.css'

class SolutionsGal {
  constructor(main, navigation) {
    this.elements = {
      main,
      navigation
    }

    this.init()
  }

  defineSlider() {
    this.slider = new Swiper(this.elements.main, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 8,
      // loop: true,
      navigation: this.elements.navigation,
      breakpoints: {
        667: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 2.5,
          spaceBetween: 24,
        },
        1440: {
          slidesPerView: 3,
          spaceBetween: 24,
        }
			},
			on: {
				init: () => this.glightboxEnable()
			}
    })
	}

	glightboxEnable() {
		if (!this.glightbox) {
			this.glightbox = GLightbox({
				selector: '.solving-video__btn',
				autoplayVideos: true
			})
		}
	}

  defineChanging() {
    this.slider.on('slideChange', () => this.glightboxEnable())
  }

  init() {
    this.defineSlider()
    this.defineChanging()
  }
}

const solutionsSectsList = document.querySelectorAll('.solutions')
solutionsSectsList.forEach(section => {
  new SolutionsGal(section.querySelector('.solutions-gal'), {
    prevEl: section.querySelector('.solutions-arrows__arrow-prev'),
    nextEl: section.querySelector('.solutions-arrows__arrow-next')
  })
})
